import {has} from "lodash"
import authentication from "@irati/auth"
import {DEVELOPMENT, E2E, STAGING, LOCAL} from "@irati/utils/constants/environment"
import env from "@irati/utils/env"


const _demoDataByLocale = {
  "en-GB": {
    staging: {
      uuid: "04a940e2-e9aa-44ac-b506-bffef75d4bd0",
      cycleId: "970f0879-2882-4583-b9da-02eaf725b0a0",
      subdomain: "demo-insights"
    },
    production: {
      uuid: "76a96efa-7023-4c81-bbce-ee4017dee998",
      cycleId: "a257e866-a0ea-42b0-8b9f-e7cf8f5363d6",
      subdomain: "demo-insights"
    }
  },
  "fr-FR": {
    staging: {
      uuid: "70234c9a-f8d4-42ea-925d-6828a3fc21d2",
      cycleId: "a64ee05d-14bf-48b6-928f-06d8dccdfca4",
      subdomain: "demo-insights-fr-fr"
    },
    production: {
      uuid: "c49964c9-cce0-4629-9f18-f8b7dc1a461a",
      cycleId: "72a75e63-e8de-471d-9818-c0b2723537f2",
      subdomain: "demo-insights-fr-fr"
    }
  }
}


/**
 * @returns {string}
 */
export default () => {
  let locale = authentication.userLocale()
  if (!has(_demoDataByLocale, locale)) {
    locale = "en-GB"
  }

  switch (env.ENVIRONMENT_NAME) {
    case LOCAL:
    case DEVELOPMENT:
    case E2E:
    case STAGING:
      return _demoDataByLocale[locale].staging
    default:
      return _demoDataByLocale[locale].production
  }
}
